import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DataService } from '../data/data.service';
import { SecurityService } from '../../services/security/security.service';

@Injectable()
export class ConsentFormService {
  constructor(
    private dataService: DataService,
    private http: HttpClient,
    private securityService: SecurityService
  ) {}

  get(): Observable<string> {
    const orderId = this.dataService.get().response.orderHeader.toOrderId;
    const url = `/api/tsorder/order/${orderId}/consent-form`;

    return this.http
      .get(url,{responseType:'text'})
      .pipe(catchError(error => this.securityService.ignoreError(error)));
  }
}
